<template>
  <div class="prism-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>n = sin((A+δmin)/2) / sin(A/2)$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Glass Prism -->
          <polygon points="200,60 140,180 260,180" fill="rgba(0, 210, 255, 0.1)" stroke="#00d2ff" stroke-width="2" />
          
          <!-- Incident Ray -->
          <line :x1="0" :y1="180 - angle*2" :x2="rayX1" :y2="rayY1" stroke="#ffd700" stroke-width="2" />
          
          <!-- Mid Ray (Inside Prism) -->
          <line :x1="rayX1" :y1="rayY1" :x2="rayX2" :y2="rayY2" stroke="#ffd700" stroke-width="1.5" />
          
          <!-- Exit Ray -->
          <line :x1="rayX2" :y1="rayY2" :x2="400" :y2="exitY" stroke="#ffd700" stroke-width="2" marker-end="url(#arrow)" />

          <!-- Normal Lines -->
          <line :x1="rayX1-20" :y1="rayY1-10" :x2="rayX1+20" :y2="rayY1+10" stroke="#888" stroke-dasharray="2" opacity="0.5" />

          <defs>
            <marker id="arrow" markerWidth="10" markerHeight="7" refX="0" refY="3.5" orient="auto">
              <polygon points="0 0, 10 3.5, 0 7" fill="#ffd700" />
            </marker>
          </defs>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>偏向角 δ: {{ deviation.toFixed(1) }}°</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <label>最小偏向角调节 (入射角): {{ angle }}°</label>
             <el-slider v-model="angle" :min="30" :max="60" size="mini"></el-slider>
          </div>
          <div class="row">
             <label>折射率 n: {{ n }}</label>
             <el-slider v-model="n" :min="1.3" :max="1.8" step="0.01" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
          <p><strong>物理详解：</strong>光经过透镜两次折射，其方向发生改变。当入射角等于出射角时，总偏向角达到<strong>最小值</strong>。通过测量三棱镜顶角 A 和最小偏向角 δ，可以精确得出玻璃的折射率。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrismViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      angle: 45,
      n: 1.5
    }
  },
  computed: {
    rayX1() { return 140 + (180 - (180 - this.angle*2)) * (60/120); }, // Rough geometric intersection
    rayY1() { return 180 - (this.angle - 30) * 2; }, 
    rayX2() { return 230; },
    rayY2() { return 150; },
    exitY() { return 220; },
    deviation() { return (this.n - 1) * 60; } // Simplified for small A
  }
}
</script>

<style scoped lang="scss">
.prism-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; 
  label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } 
}
.discovery-note { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
